import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { useDeleteJob } from '../hooks/useJobMutations';

export const DeleteConfirmModal = (props) => {
  const { isOpen, onClose, job } = props;
  const { mutate: deleteJob, isPending } = useDeleteJob();

  if (!isOpen || !job) return null;

  const handleDelete = () => {
    deleteJob(job._id, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm'>
      <div className='bg-card rounded-lg shadow-xl w-full max-w-md border border-border'>
        {/* Header */}
        <div className='flex items-center justify-between px-6 py-4 border-b border-border'>
          <h3 className='text-lg font-semibold text-foreground'>Confirm Delete</h3>
          <button
            onClick={onClose}
            className='text-muted-foreground hover:text-foreground transition-colors'
            type='button'
            disabled={isPending}
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className='p-6'>
          <div className='flex items-start gap-4'>
            <div className='flex-shrink-0 w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center'>
              <AlertTriangle size={24} className='text-destructive' />
            </div>
            <div className='flex-1'>
              <h4 className='text-base font-semibold text-foreground mb-2'>Delete Job?</h4>
              <p className='text-sm text-muted-foreground mb-4'>
                Are you sure you want to delete the job{' '}
                <span className='font-semibold text-foreground'>"{job.jobTitle}"</span>? This action cannot be undone.
              </p>
              <div className='p-3 bg-destructive/5 border border-destructive/20 rounded-md'>
                <p className='text-xs text-destructive'>
                  Warning: This will permanently delete the job and all associated data.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className='flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3 px-6 py-4 border-t border-border'>
          <button
            type='button'
            onClick={onClose}
            className='flex-1 px-4 py-2 border border-border rounded-md text-foreground hover:bg-accent transition-colors'
            disabled={isPending}
          >
            Cancel
          </button>
          <button
            type='button'
            onClick={handleDelete}
            className='flex-1 px-4 py-2 bg-destructive text-destructive-foreground rounded-md hover:bg-destructive/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
            disabled={isPending}
          >
            {isPending ? (
              <div className='flex items-center justify-center'>
                <div className='animate-spin rounded-full h-4 w-4 border-b-2 border-destructive-foreground mr-2' />
                Deleting...
              </div>
            ) : (
              'Delete Job'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
